import styled from 'styled-components'

import theme from 'theme_'
import { CommonButton } from 'components/Button'
import { WhiteBlock } from 'components/Layout'
import Icon from '@mdi/react'

export const StyledUpgradeSubscriptionWrapper = styled.div`
  width: 100%;
`

export const StyledPaymentMethods = styled(WhiteBlock)`
  padding-bottom: ${theme.spacing.base};
`

export const StyledCardsBlock = styled.div`
  margin-bottom: ${theme.spacing.base};
`

export const StyledAddPromocodeBtn = styled(CommonButton)`
  height: 32px;
`
export const StyledPromocodeRow = styled.div`
  display: flex;
  justify-content: space-between;
`
export const PurchaseSuccessIcon = styled(Icon)`
  color: ${theme.colors.success};
`

export const PurchaseErrorIcon = styled(Icon)`
  color: ${theme.colors.error};
`
